import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDate, normalizeImageUrl } from "@/lib/api";
import { Calendar, MapPin, ArrowRight } from "lucide-react";

export default function Activities() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/activities").then(r => setItems(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <div className="mb-12">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700 mb-3">Kegiatan</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-emerald-950">Kegiatan LSP REI</h1>
        <p className="mt-4 text-slate-600 max-w-2xl">Sertifikasi, asesmen, seminar, workshop, dan sosialisasi.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map(it => (
          <article key={it.id} data-testid={`activity-${it.id}`} className="bg-white rounded-2xl overflow-hidden border border-slate-100 hover:shadow-xl transition-shadow group">
            <div className="aspect-[16/10] overflow-hidden">
              <img src={normalizeImageUrl(it.photo_url)} alt={it.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-6">
              <div className="inline-block text-xs font-bold uppercase tracking-widest text-amber-600 mb-2">{it.category}</div>
              <h3 className="font-display font-bold text-xl text-emerald-950 leading-snug">{it.title}</h3>
              <div className="mt-3 flex flex-wrap gap-3 text-xs text-slate-600">
                <span className="inline-flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {fmtDate(it.date)}</span>
                <span className="inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {it.location}</span>
              </div>
              <p className="text-sm text-slate-600 mt-3 line-clamp-2">{it.description}</p>
            </div>
          </article>
        ))}
        {items.length === 0 && <div className="col-span-3 text-center py-16 text-slate-500">Belum ada kegiatan.</div>}
      </div>
    </div>
  );
}
